import { useState } from 'react';
import { useCart } from '../../contexts/CartContext';
import CartDrawer from './CartDrawer';

export default function CartButton() {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { getCartCount } = useCart();
  const cartCount = getCartCount();

  return (
    <>
      <button
        onClick={() => setIsCartOpen(true)}
        className="relative w-10 h-10 flex items-center justify-center text-white hover:text-teal-300 transition-colors"
      >
        <i className="ri-shopping-cart-line text-2xl"></i>
        {cartCount > 0 && (
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
            {cartCount > 9 ? '9+' : cartCount}
          </span>
        )}
      </button>

      <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </>
  );
}
